package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware

enum class KitchenLocationPrintersEnum(
    val title:String,
    val value:String,
)
{
    EPSON_M30(
        title ="EPSON M30" ,
        value ="EPSON_M30"
    ),
    SUNMI_CLOUD_BY_IP(
        title ="SUNMI Cloud by IP" ,
        value ="SUNMI_CLOUD_BY_IP"
    ),
    SUNMI_CLOUD_BY_SERVER(
        title = "SUNMI Cloud by Server",
        value ="SUNMI_CLOUD_BY_SERVER"
    ),
    KITCHEN_DISPLAY_KDS(
        title ="Kitchen Display (KDS)" ,
        value ="KITCHEN_DISPLAY_KDS"
    ),

}
